import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../../elements/ButtonLink';
import IconAdd from '../../icons/IconAdd';
import IlluEmptyNotification from '../../icons/IlluEmptyNotification';
import styles from './styles.scoped.css';

export function NotificationEmpty({ isButtonAdd }) {
  return(
    <section className={styles['empty-notification-wrapper']}>
      <IlluEmptyNotification />
      <div>
        <h5>Tidak ada notifikasi aktif</h5>
        <small>
          Tambah notifikasi baru atau atur periode aktif notifikasi untuk ditampilkan di MAP Lite.
        </small>
        {isButtonAdd &&
            <ButtonLink
              className={styles['button-add']}
              outlined
              to="/notification/add"
              type="primary">
              <IconAdd style={{ fill: 'rgba(15, 110, 181, 1)' }}/>
                Tambah Notifikasi Baru
            </ButtonLink>}
      </div>
    </section>
  );
}

export default NotificationEmpty;

NotificationEmpty.propTypes = {
  isButtonAdd: PropTypes.bool
};

